// Aggregates landing section components & initializes AOS once
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Ensure AOS styles loaded only once
import TopComponent from "./TopComponent";
import JTSS from "./JTSS";
import WCU from "./WCU";
import ContactUs from "./ContactUs";
import "./landing.css";

const LandingPage = () => {
  useEffect(() => {
    // Initialize AOS once with consistent settings
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false, // allow replay on scroll up/down
      mirror: true, // animate on scroll up as well
      startEvent: "DOMContentLoaded",
      disable: false, // never disable on desktop
    });

    // Refresh after images/fonts load to ensure correct offsets
    const handleLoad = () => {
      AOS.refreshHard();
    };
    window.addEventListener("load", handleLoad);
    // Also refresh on resize/orientation change (debounced)
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => AOS.refresh(), 200);
    };
    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("load", handleLoad);
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  return (
    <div
      className="landing-root"
      // style={{ fontFamily: "Helvetica, Arial, sans-serif" }}
      style={{ fontFamily: "Helvetica, Helvetica, Helvetica" }}
    >
      <TopComponent />
      <JTSS />
      <WCU />
      <ContactUs />
    </div>
  );
};

export default LandingPage;
